import React from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import OperationsTabContentContainer from '../containers/Operations/TabContentContainer'
import ConsumerApiTabContentContainer from '../containers/ConsumerApi/TabContentContainer'
import DataquestTabContentContainer from '../containers/Dataquest/TabContentContainer'
import ShogunTabContentContainer from '../containers/Shogun/TabContentContainer'
import MonitoringTabContentContainer from '../containers/Monitoring/TabContentContainer'

import '../../stylesheets/AdminStatuses.css';

const AdminStatusDashboard = (props) => {
  return(
    <div className="container AdminStatuses">
      <h2>Status Dashboard</h2>
      <Tabs defaultActiveKey={1} unmountOnExit={true} id="admin-status-page-tabs">
        <Tab eventKey={1} title="Operations">
          <OperationsTabContentContainer />
        </Tab>
        <Tab eventKey={2} title="Consumer API">
          <ConsumerApiTabContentContainer />
        </Tab>
        <Tab eventKey={3} title="Dataquest">
          <DataquestTabContentContainer />
        </Tab>
        <Tab eventKey={4} title="Shogun">
          <ShogunTabContentContainer />
        </Tab>
        <Tab eventKey={5} title="Monitoring">
          <MonitoringTabContentContainer />
        </Tab>
      </Tabs>
    </div>
  )
}

export default AdminStatusDashboard;


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/AdminStatusDashboard.jsx